import { getTeamLogoPath } from '../../lib/teamLogos'
import './TeamLogo.css'

export default function TeamLogo({ teamName, sportKey, size = 20 }) {
  const path = getTeamLogoPath(teamName, sportKey)
  if (!path) return null
  return (
    <img
      className="team-logo"
      src={path}
      alt={teamName}
      width={size}
      height={size}
      onError={(e) => { e.target.style.display = 'none' }}
      loading="lazy"
    />
  )
}
